"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shortcut = void 0;
var Shortcut_1 = __importDefault(require("./Shortcut"));
exports.Shortcut = Shortcut_1.default;
exports.default = Shortcut_1.default;
//# sourceMappingURL=index.js.map